"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoldIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _bold = _interopRequireDefault(require("../../../../../../images/bold.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BoldIcon = function BoldIcon(_ref) {
  var boldState = _ref.boldState,
    resetIconState = _ref.resetIconState,
    setBoldState = _ref.setBoldState;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "action-icon",
    onClick: function onClick() {
      resetIconState();
      setBoldState(!boldState);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _bold.default,
    className: boldState ? 'bordered' : 'simple',
    alt: "Bold"
  }));
};
exports.BoldIcon = BoldIcon;